'use client'

import { useApplySuggestedFilters, useFetchAISuggestions } from '@/src/hooks/srp/aiRecommendation'
import { useSortManager } from '@/src/hooks/srp/sortManager'
import useSearchResults from '@/src/hooks/srp/useSearchResults'
import { resetAllAIState, setTextInput } from '@/src/redux/slices/aiRecommendationSlice'
import { setOnwardSelectedSort, setReturnSelectedSort } from '@/src/redux/slices/srpStatesSlice'
import { useAppDispatch } from '@/src/redux/store'
import { useCallback, useEffect } from 'react'
import { useAIFeatureEnableManager } from '../../AIFeatureEnableManager'
import { useGetSearchParamsObj } from '../searchParams'

/**
 * SRP AI filter: fetch suggestions, apply filters to results, then switch sort to Smart for the active leg.
 */
export function useSRPAIFilterManager (autoSearchWithQueryParam = false) {

    const { srpSmartFilterSort } = useAIFeatureEnableManager()
    const dispatch = useAppDispatch()
    const { query, srpResultsError, srpResultsLoading, invalidUrl, selectedJourneyLeg } =
        useSearchResults()
    const { fetchSuggestions } = useFetchAISuggestions()
    const { applySuggestedFilters } = useApplySuggestedFilters()
    const { sortOptions } = useSortManager()
    const { urlQueryObj } = useGetSearchParamsObj()
    const aiFilterQuery = urlQueryObj.ai_filter_query
    const smartSortOption = sortOptions.find(option => option.sortKey === 'smart')
    const smartSortDisplayValue = smartSortOption?.label || 'Smart'

    const applySmartSortForCurrentLeg = useCallback(() => {
        const nextSort = {
            sortKey: 'smart' as const,
            displayValue: smartSortDisplayValue
        }
        if (selectedJourneyLeg === 0) {
            dispatch(setOnwardSelectedSort(nextSort))
        } else {
            dispatch(setReturnSelectedSort(nextSort))
        }
    }, [dispatch, selectedJourneyLeg, smartSortDisplayValue])

    const applySmartAiFilters = useCallback(
        async (naturalLanguageInput: string) => {
            const payload = await fetchSuggestions(naturalLanguageInput)
            if (!payload) return
            applySuggestedFilters(payload)
            applySmartSortForCurrentLeg()
        },
        [applySmartSortForCurrentLeg, applySuggestedFilters, fetchSuggestions]
    )


    //auto search
    useEffect(() => {
        if (!srpResultsError && !srpResultsLoading && !invalidUrl && autoSearchWithQueryParam && srpSmartFilterSort) {


            if (aiFilterQuery) {
                applySmartSortForCurrentLeg()
                applySmartAiFilters(aiFilterQuery)
                dispatch(setTextInput({ leg: selectedJourneyLeg, value: aiFilterQuery }))
            } else {
                dispatch(resetAllAIState())
            }


        }


    }, [query, srpResultsError, srpResultsLoading, invalidUrl, autoSearchWithQueryParam, srpSmartFilterSort])

    return { applySmartAiFilters }
}
